import { render, staticRenderFns } from "./ExperienceTag.vue?vue&type=template&id=498fe7db&scoped=true&"
import script from "./ExperienceTag.vue?vue&type=script&lang=js&"
export * from "./ExperienceTag.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceTag.vue?vue&type=style&index=0&id=498fe7db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498fe7db",
  null
  
)

export default component.exports